import * as React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom'
import { Button, CardLink, Col, Container, Fade, Row, Input } from "reactstrap";
import { Dispatch } from 'redux';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faTimes, faEdit, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import ReactPaginate from 'react-paginate';
import { userAction } from '../../actions/userAction';
import { showAlert } from "../common/functions";
import { DABDropDown, ConfirmModal, LoadingSpinnerModal } from '../../components/dab';
import { getIsAdminLogged } from '../../services/selectors/Accounts';

interface IUserProps {
	dispatch: Dispatch<any>;
	userData: any;
}

const UserList: React.SFC<IUserProps> = ({ dispatch, userData }) => {

	const history = useHistory();

	const initialValue = [{ text: "", value: "", checked: false }];
	const initialInputValue =
	{
		pageNumber: 1,
		pageSize: 25,
		sortColumn: "",
		roleCode: ["Admin", "Channel", "Community", "Episode"],
		sortDirection: "desc",
		searchString: ""
	};

	const [fadeIn, setFadeIn] = useState(false);
	const [selectedRole, setSelectedRole] = useState("");
	const [selectedId, setSelectedId] = useState(0);
	const [currentPageNo, setCurrentPageNo] = useState(0);
	const [pageList, setPageList] = useState([1]);
	const [filterInput, setFilterInput] = useState(initialInputValue);
	const [showModal, setShowModal] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [showClearFilter, setShowClearFilter] = useState(false);
	const [rolesList, setRolesList] = useState(initialValue);
	const [isRoleLoaded, setIsRoleLoaded] = useState(false);
	const [isRestore, setIsRestore] = useState(false);

	const handleLoadShowModal = (value: boolean) => {
		setShowModal(value);
	};

	const handleFilterClose = () => {
		handleToggle();
	}

	const handleFilterClear = () => {
		setFadeIn(false);
		setShowClearFilter(false);
		sessionStorage.removeItem("Filter");
		setFilterInput(initialInputValue);
		setSelectedRole("");
	}

	const handleToggle = () => setFadeIn(!fadeIn);

	const handleFilter = () => {
		setCurrentPageNo(0);
		userData.isFilterAndTotalCountDataLoaded = true;
		setShowClearFilter(true);
		handleToggle();
		var role = selectedRole === "" ? ["Admin", "Channel", "Community", "Episode"] :[selectedRole];
		setFilterInput({ ...filterInput, roleCode: role, pageNumber:1 })
		setShowModal(true);
	};

	const handleSort = (sortColumn) => {
		var input = filterInput;
		var sDir = "asc"
		if (input.sortColumn === sortColumn) {
			if (input.sortDirection === "desc") {
				sDir = "asc";
			}
			else {
				sDir = "desc";
			}
		}
		setFilterInput({
			...filterInput,
			sortColumn: sortColumn,
			sortDirection: sDir
		})
	};

	const handleSetPageNumber = (pageNo) => {
		setFilterInput({
			...filterInput,
			pageNumber: pageNo,
		});
	};

	const handleSortIcon = (sortColumn) => {
		var input = filterInput;
		if (input.sortColumn === sortColumn) {
			if (input.sortDirection === "desc") {
				return <FontAwesomeIcon className='column-sort-icon' icon={faChevronUp} />
			}
			else {
				return <FontAwesomeIcon className='column-sort-icon' icon={faChevronDown} />
			}
		}
	}

	const handleDeleteModal = (value: boolean) => {
		if (value) {
			dispatch(userAction.userDelete(selectedId));
			setShowModal(true);
		}
		setShowDeleteModal(false);
	};

	const handleSelectForDelete = (id: number) => {
		setSelectedId(id);
		setShowDeleteModal(true);
	}

	const handleGetSortColumn = (display, value) => {
		return <div className='column-div' onClick={(e) => { handleSort(value); }}>
			{display}
			{value === filterInput.sortColumn && (handleSortIcon(value))}
		</div>
	}

	const handlePageClick = (data) => {
		handleSetPageNumber(data.selected + 1);
		setCurrentPageNo(data.selected);
	};

	React.useEffect(() => {		
		if (!getIsAdminLogged()) {
			window.location.href = "/401"
		}
	}, [])

	React.useEffect(() => {
		if (!isRoleLoaded) {
			dispatch(userAction.userRoleGetByFilter());
		}

		var fromPage = sessionStorage.getItem("fromPage");

		if (fromPage && fromPage.trim().toLowerCase() === 'user') {
			handleFilterRestore();
		}

		if (initialInputValue != filterInput) {
			sessionStorage.setItem("Filter", JSON.stringify(filterInput)); 
		} else {
			sessionStorage.removeItem("Filter");
		}

		dispatch(userAction.userGetByFilter(filterInput));
		setShowModal(true);
	}, [filterInput]);

	const handleFilterRestore = () => {
		var filter = sessionStorage.getItem("Filter");
		if (filter != null && filter.trim() != "") {
			var filterObj = JSON.parse(filter.toString());
			if (filterObj != null) {
				setShowClearFilter(true);
				setIsRestore(true);
				setSelectedRole("Channel");
				setFilterInput(filterObj);
				setCurrentPageNo(filterObj.pageNumber - 1)				
				sessionStorage.removeItem("fromPage");
			}
		}
	}

	const handleInputChange = (event) => {
		let value = event.target.value;		
		setSelectedRole(value);
	};

	if (showModal && !userData.isLoading) {
		if (userData.isListSuccess && userData.isSuccess) {
			userData.isSuccess = false;
			setShowModal(false);
			var total: number = userData.totalCount;
			var pList: number[] = [];
			if (total > 25) {
				for (var i = 1; i <= (total / 25); i++) {
					pList.push(i);
				}

				if ((total % 25) > 0) {
					pList.push((parseInt((total / 25).toString()) + 1));
				}
			}
			else {
				pList.push(1);
			}
			setPageList(pList);
		}
	}

	if (!isRoleLoaded && !userData.isLoading) {
		if (userData.isRoleListSuccess) {
			userData.isRoleListSuccess = false;
			userData.isSuccess = false;
			setIsRoleLoaded(true);
			if (rolesList && rolesList.length <= 1) {
				var list: any[] = [];
				list.push({ text: "All Roles", value: "", checked: true });
				var item = { text: "Admin", value: "Admin", checked: false };
				list.push(item);
				userData.rolesList.forEach((data) => {
					var item1 = { text: data.roleName, value: data.roleCode, checked: false };
					list.push(item1);
				});
				setRolesList(list);
				isRestore ? setSelectedRole(filterInput.roleCode[0]) : setSelectedRole(list[0].value);
			}
		}
	}

	if (selectedId >= -1 && userData.isDeleteCompleted && !userData.isError) {
		showAlert(userData.status, false);
		userData.isSuccess = false;
		userData.isDeleteCompleted = false;
		dispatch(userAction.userGetByFilter(filterInput));
		setSelectedId(-1);
	}

	if (selectedId >= 0 && !userData.isSuccess && userData.isDeleteCompleted && userData.isError) {
		userData.isError = false;
		userData.isDeleteCompleted = false;
		if (userData.status === 'Unauthorized') {
			history.push("/401");
		} else {
			showAlert(userData.status, true);
		}
		setSelectedId(-1);
		if (showModal) {
			setShowModal(false);
		}
	}

	if (userData.isListSuccess && userData.isError && !userData.isSuccess) {
		userData.isError = false;
		if (userData.status === 'Unauthorized') {
			history.push("/401");
		} else {
			showAlert(userData.status, true);
		}
		setShowModal(false);
	}

	const handleDetailNavigation = (data) => {
		sessionStorage.setItem("fromPage", "user")
		window.location.href = "/user?id=" + data.userId;
	}

	return (
		<div>
			<div className="user-list">
				<div className='card-box'>
					<Row className='filter-link-container'>
						<Col lg="8" className='column'>
							<CardLink onClick={handleToggle} className='card-box-link'>Filter List</CardLink>
							{showClearFilter ?
								<CardLink onClick={handleFilterClear} className='card-box-link-filter'>Clear Filter</CardLink>
								: <CardLink className='card-box-link-filter-disabled'>Clear Filter</CardLink>}
						</Col>
						<Button data-testid="createNewUser" id="submit" className="btn-submit-frm" onClick={() => { window.location.href = "/user?page=add"; }}>Create New</Button>
					</Row>
					{fadeIn && (
						<Fade in={fadeIn} tag="div" className='card-fade'>
							<Row>
								<Col lg="7">
									<Container className='filter-container'>
										<div className='box-container'>
											<div>
												<Row>
											<Col lg="11">
												<Row>
													<Col lg="8">
														<label>Roles</label>
														<div>														
															<DABDropDown type="select" className="form-select" id="roleCode" isRequired={true} value={selectedRole} onChange={(event) => { handleInputChange(event); }} options={rolesList} />
														</div>
													</Col>
													<Col lg="2">
														<label>&nbsp;</label>
														<div>
															<Button type="button" id="submit" className="inner-filter-link"
																onClick={() => { handleFilter(); }}>Filter</Button>
														</div>
													</Col>
												</Row>
											</Col>
											<Col lg="1">
												<div className='close-div'>
													<FontAwesomeIcon cursor='pointer' size='3x' data-bs-toggle="tooltip"
														data-bs-placement="bottom" title="Close" icon={faTimes}
														onClick={handleFilterClose} />
												</div>
											</Col>
											</Row>
											</div>
										</div>
									</Container>
								</Col>
							</Row>
						</Fade>)}
				</div>
				<div className="user-table">
					<table className="table table-hover" data-testid="usersTable">
						<thead data-testid="usersTableHead">
							<tr>
								<th scope="col" data-testid="detail-th">Details</th>
								<th scope="col" data-testid="name-th">{handleGetSortColumn("Name", "Name")}</th>
								<th scope="col" data-testid="email-th">{handleGetSortColumn("Email", "EMAIL")}</th>
								<th scope="col" data-testid="roles-th">Roles</th>
								<th scope="col" data-testid="delete-th">Delete</th>
							</tr>
						</thead>
						<tbody data-testid="usersTableBody">
							{userData && userData.items.map((data: any) =>
								<tr key={data.userId} >
									<th scope="row">
										<FontAwesomeIcon cursor='pointer' size='2x' icon={faEdit} title="Details"
											onClick={() => {handleDetailNavigation(data)}} />
									</th>
									<td id="fullname">{data.name}</td>
									<td id="userName">{data.email}</td>
									<td id="roles">{data.roles?.substring(data.roles.length - 1, data.roles.length) == "," ? data.roles.substring(0, data.roles.length-1) : data.roles}</td>
									<td>
										<FontAwesomeIcon data-testid="deleteUserButton" cursor='pointer' size='2x' icon={faTrashAlt} data-bs-toggle="tooltip"
											data-bs-placement="bottom" title="Delete" onClick={() => { handleSelectForDelete(data.userId) }} />
									</td>
								</tr>
							)}
							{userData && userData.items.length <= 0 &&
								<tr className="no-data">
									<th scope="row" colSpan={5}>
										<h4> No data found </h4>
									</th>
								</tr>}
						</tbody>
					</table>
				</div>
				<div className="pagination">
					<ReactPaginate
						previousLabel={'<<'}
						nextLabel={'>>'}
						breakLabel={'...'}
						pageCount={pageList.length}
						marginPagesDisplayed={2}
						pageRangeDisplayed={20}
						onPageChange={handlePageClick}
						forcePage={currentPageNo}
						containerClassName={'pagination'}
						pageClassName={"page-item"}
						previousClassName={"page-item"}
						breakClassName={"page-item"}
						breakLinkClassName={"page-link"}
						nextClassName={"page-item"}
						pageLinkClassName={"page-link"}
						previousLinkClassName={"page-link"}
						nextLinkClassName={"page-link"}
						activeClassName={'active'}
					/>
				</div>
				{
					showModal && (
						<LoadingSpinnerModal isShowModal={showModal} modalChange={handleLoadShowModal} />
					)
				}
				<ConfirmModal isShowModal={showDeleteModal} deleteMessage={"Are you sure, Do you want to remove this user? "} modalChange={handleDeleteModal} />
			</div>
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { userData } = state;
	return {
		userData
	};
};

export default connect(mapStateToProps)(UserList);
